import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Stack,
  IconButton,
  Divider,
  Checkbox,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ShipmentInquiriesService from "../../services/ShipmentInquiriesService";
import { useHistory, useLocation } from "react-router-dom";
import { snackbarActions } from "../../Store/snackbar";
import { useDispatch } from "react-redux";

const ShipmentRequestConfirmationDialog = ({
  open,
  onClose,
  onSuccess,
  onConfirm,
  selectedRows,
  payload,
}) => {
  const [checked, setChecked] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const requestId = queryParams.get("request_id");

  const handleConfirmSubmit = () => {
    const finalPayload = {
      ...payload,
      request_id: requestId,
    };

    const apiCall = requestId
      ? ShipmentInquiriesService.updateShipmentRequest
      : ShipmentInquiriesService.submitNewShipment;

    apiCall(finalPayload)
      .then(() => {
        commonDispatch(
          "success",
          requestId
            ? "Shipment Request updated successfully"
            : "Shipment Request submitted successfully"
        );

        history.push("/sample-distribution/shipment_request");
      })
      .catch((err) => {
        commonDispatch(
          "error",
          err?.response?.data?.detail || "Something went wrong"
        );
      });
  };

  const commonDispatch = (type, message) => {
    dispatch(
      snackbarActions.showNotification({
        snackbarOpen: true,
        snackbarType: type,
        snackbarMessage: message,
      })
    );
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>

      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
        }}
      >
        <Box>
          <Typography sx={{ fontWeight: 600, fontSize: "18px" }}>
            Confirm Shipment Request
          </Typography>
          <Typography sx={{ fontSize: "13px", color: "#666" }}>
            Review the details below before submitting.
          </Typography>
        </Box>

        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent>

        <Box
          sx={{
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            p: 2,
            mb: 2,
            background: "#fafafa",
          }}
        >
          <Stack spacing={1}>

            <Row label="Samples" value={`${payload.inventory_codes.length} samples`} />

            <Row
              label="Inventory Codes"
              value={payload.inventory_codes.join(", ")}
            />

            <Row label="Destination" value={payload.destination_site || "--"} />
            <Row label="Address" value={payload.shipping_address || "--"} />

            <Row
              label="Ship Date / Time"
              value={
                payload.ship_date && payload.ship_time
                  ? `${payload.ship_date} ${payload.ship_time}`
                  : "--"
              }
            />

            <Row label="Carrier" value={payload.carrier || "--"} />

            <Row label="Temperature" value={payload.temprature || "--"} />
          </Stack>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: 1,
            p: 1.5,
            border: "1px solid #f0c36d",
            background: "#fff8e1",
            borderRadius: "6px",
            mb: 2,
          }}
        >
          <WarningAmberIcon sx={{ color: "#f59e0b" }} />
          <Typography sx={{ fontSize: "13px" }}>
            <b>This request cannot be edited after submission.</b> Any
            changes will require cancelling and resubmitting.
          </Typography>
        </Box>

        <Stack direction="row" alignItems="center" spacing={1}>
          <Checkbox
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
          />
          <Typography sx={{ fontSize: "13px" }}>
            I confirm sample chain-of-custody requirements have been met.
          </Typography>
        </Stack>

      </DialogContent>

      <Divider />

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} variant="text">
          BACK TO EDIT
        </Button>

        <Button
          variant="contained"
          disabled={!checked}
          onClick={handleConfirmSubmit}
        >
          CONFIRM & SUBMIT
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const Row = ({ label, value }) => {
  return (
    <Stack direction="row" spacing={2}>
      <Typography
        sx={{
          fontSize: "13px",
          color: "#777",
          minWidth: "140px",
        }}
      >
        {label}
      </Typography>

      <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
        {value}
      </Typography>
    </Stack>
  );
};

export default ShipmentRequestConfirmationDialog;
